import MyProgram from "./myProgram";
import MyApplication from "./myApplication";

const Educators = {
  MyProgram,
  MyApplication
};

export default Educators;
